/* tslint:disable */
/* eslint-disable */
/* @relayHash 9496e01fce0040becb7043157104bdf0 */

import { ConcreteRequest } from "relay-runtime";
export type COMMENT_STATUS = "APPROVED" | "NONE" | "PREMOD" | "REJECTED" | "SYSTEM_WITHHELD" | "%future added value";
export type COMMENT_VIEWER_ACTION = "APPROVE" | "CREATE" | "EDIT" | "REJECT" | "%future added value";
export type EditCommentInput = {
    commentID: string;
    body: string;
    clientMutationId: string;
    media?: CreateCommentMediaInput | null;
};
export type CreateCommentMediaInput = {
    type: string;
    id?: string | null;
    url: string;
    width?: string | null;
    height?: string | null;
};
export type EditCommentMutationVariables = {
    input: EditCommentInput;
};
export type EditCommentMutationResponse = {
    readonly editComment: {
        readonly comment: {
            readonly id: string;
            readonly body: string | null;
            readonly status: COMMENT_STATUS;
            readonly revision: {
                readonly id: string;
                readonly media: ({
                    readonly __typename: "GiphyMedia";
                    readonly url: string;
                    readonly title: string | null;
                    readonly width: number | null;
                    readonly height: number | null;
                    readonly still: string;
                    readonly video: string;
                } | {
                    readonly __typename: "ExternalMedia";
                    readonly url: string;
                } | {
                    readonly __typename: "TwitterMedia";
                    readonly url: string;
                    readonly width: number | null;
                } | {
                    readonly __typename: "BlueskyMedia";
                    readonly url: string;
                    readonly width: number | null;
                } | {
                    readonly __typename: "YouTubeMedia";
                    readonly url: string;
                    readonly width: number | null;
                    readonly height: number | null;
                } | {
                    /*This will never be '%other', but we need some
                    value in case none of the concrete values match.*/
                    readonly __typename: "%other";
                }) | null;
            } | null;
            readonly editing: {
                readonly edited: boolean;
            };
            readonly lastViewerAction: COMMENT_VIEWER_ACTION | null;
        };
        readonly clientMutationId: string;
    };
};
export type EditCommentMutation = {
    readonly response: EditCommentMutationResponse;
    readonly variables: EditCommentMutationVariables;
};



/*
mutation EditCommentMutation(
  $input: EditCommentInput!
) {
  editComment(input: $input) {
    comment {
      id
      body
      status
      revision {
        id
        media {
          __typename
          ... on GiphyMedia {
            url
            title
            width
            height
            still
            video
          }
          ... on ExternalMedia {
            url
          }
          ... on TwitterMedia {
            url
            width
          }
          ... on BlueskyMedia {
            url
            width
          }
          ... on YouTubeMedia {
            url
            width
            height
          }
        }
      }
      editing {
        edited
      }
    }
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any)
    ], v1 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v2 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
    } as any), v3 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "width",
        "storageKey": null
    } as any), v4 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "height",
        "storageKey": null
    } as any), v5 = [
        (v2 /*: any*/),
        (v3 /*: any*/)
    ], v6 = [
        ({
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "EditCommentPayload",
            "kind": "LinkedField",
            "name": "editComment",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "comment",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "body",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CommentRevision",
                            "kind": "LinkedField",
                            "name": "revision",
                            "plural": false,
                            "selections": [
                                (v1 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "media",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "__typename",
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v2 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "title",
                                                    "storageKey": null
                                                },
                                                (v3 /*: any*/),
                                                (v4 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "still",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "video",
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "GiphyMedia",
                                            "abstractKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v2 /*: any*/)
                                            ],
                                            "type": "ExternalMedia",
                                            "abstractKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": (v5 /*: any*/),
                                            "type": "TwitterMedia",
                                            "abstractKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": (v5 /*: any*/),
                                            "type": "BlueskyMedia",
                                            "abstractKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v3 /*: any*/),
                                                (v4 /*: any*/)
                                            ],
                                            "type": "YouTubeMedia",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EditInfo",
                            "kind": "LinkedField",
                            "name": "editing",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "edited",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "kind": "ClientExtension",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "lastViewerAction",
                                    "storageKey": null
                                }
                            ]
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any)
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "EditCommentMutation",
            "selections": (v6 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "EditCommentMutation",
            "selections": (v6 /*: any*/)
        },
        "params": {
            "id": "9496e01fce0040becb7043157104bdf0",
            "metadata": {},
            "name": "EditCommentMutation",
            "operationKind": "mutation",
            "text": null
        }
    } as any;
})();
(node as any).hash = 'dac0bf57d08ee9c94ebc10e8346728e6';
export default node;
